import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkin = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 43,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4,
			width: 44,
			height: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 6,
			width: 40,
			height: 36,
			rx: 1,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 13,
			width: 28,
			height: 30,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 16,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 20,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 32,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 24,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 36,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 28,
			width: 22,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		})
	]
});
export default SvgSkin;
